import React from 'react';
import { StoresContext } from '../../../../app/root/domain/stores/StoresContext';

export const useVehicleStores = () => React.useContext(StoresContext);
